import {
  BannerContainer,
  BannerText,
  IllustrationContainer,
} from "./ResourcesBanner.styles";
import { DocumentsIllustration } from "./DocumentsIllustration";

export default () => {
  return (
    <BannerContainer>
      <BannerText>Documents</BannerText>
      <IllustrationContainer>
        <DocumentsIllustration />
      </IllustrationContainer>
    </BannerContainer>
  );
};
